import api from '@/api';

/**
 * 根据仓库ID集合获取审批流列表
 * @param {number[]} warehouseIds - 仓库ID集合
 * @returns {Promise<object>} 与 api.cims.getFlowsByWarehouseIds 相同结构的响应对象
 */
function getRequestApprovalFlows(warehouseIds) {
  const params = warehouseIds.map(id => ({ WarehouseId: id }));
  return api.cims.getFlowsByWarehouseIds(params);
}

/**
 *
 * @param {number} amounts 申购金额
 * @returns {Promise<object[]>} 审批流列表，包含自选审批人信息
 */
function getApplicantOptionFlows(amounts) {
  const params = amounts.map(amount => ({ Amount: amount }));
  return api.cims.getFlowsByAmounts(params);
}

/**
 * 根据仓库ID集合判断是否存在自选审批人的审批流
 * @param {number[]} list - 仓库ID集合或申购金额集合
 * @param {string} type - 操作类型 （'request' 领用；'applicant' 申购）
 * @returns {Promise<[boolean, object[]]>} 包含是否存在自选审批人和审批流列表的数组
 */
export async function getOptionFlows(type, list) {
  const resp = type === 'request' ? await getRequestApprovalFlows(list) : await getApplicantOptionFlows(list);
  if (resp.code != process.env.VUE_APP_code) return [false, []];
  const flows = resp.response || [];
  const hasOptional = flows.some(flow => flow.HasOptional === 1);
  return [hasOptional, flows];
}
